// 基础数据
import { $post, $get,$patch} from '@/utils/http'
import Service from './Service'

// 接口集合
const _url = {
    // 获取城市区域列表
    REGIONSDATA: '/ucenter/v2/projects/region',
    // 获取计费方案
    CHARGESCHEME: `/ucenter/project/jifeifangan`,
}

// 获取城市区域列表
Service.getRegionsData = async function (params) {
    let request = {}
    request['oid'] = params  
    let data = await $post(_url.REGIONSDATA, request);
    let fmtData = Service.handleCommonError(data);
    return fmtData.map(v=>{
        if (v.RegionType !== 3) {
            v.cities = []
        }
        return v
    })
}

// 获取省份
Service.getProvince = async function () {
    let data = await $get("/ucenter/v2/projects/province");
    return Service.handleCommonError(data);
}
// 获取城市 
Service.getCity = async function (params) {
    let request = {}
    request["oid"] = params.oid
    let data = await $get("/ucenter/v2/projects/city", params);
    return Service.handleCommonError(data);
}
// 获取市辖区
Service.getCountry = async function (params) {
    let request = {}
    request["oid"] = params.oid
    let data = await $get("/ucenter/v2/projects/country", params);
    return Service.handleCommonError(data);
}
// 获取街道
Service.getTown = async function (params) {
    let request = {}
    request["oid"] = params.oid
    let data = await $get("/ucenter/v2/projects/town", params);
    return Service.handleCommonError(data);
}

// 获取经纬度   
Service.getCoordinate = async function (params) {
    let request = {}
    request["address"] = params.address
    let data = await $get("/ucenter/v2/projects/coordinate", params);
    return Service.handleCommonError(data);
}

// 获取计费方案列表
// Service.getChargeSchemeList = async function (params) {
//     let request = {}
//     // 计费策略是否可用（0获取所有，1获取可用，2获取不可用）
//     request['usabletype'] = params.usabletype || 0;  
//     let data = await $get('/ucenter/v2/base/listrule', request, true);
//     return Service.handleCommonError(data)
// }

// 获取计费方案列表
Service.getChargeSchemeList = async function (params) {
    let request = {}
    // 计费策略是否可用（0获取所有，1获取可用，2获取不可用）
	request['project_sys_id'] = Service.getProjectSystemId();
	
    let data = await $get('/ucenter/v2/base/rule/pid', request, true);
    return Service.handleCommonError(data)
}



// 根据id获取计费策略
Service.getChargeSchemeInfo = async function (params) {
    let request = {}
    // 计费策略id
    request['oid'] = params.OID;
    let data = await $get('/ucenter/v2/base/rule', request, true);
    return Service.handleCommonError(data)
}

// 修改计费策略
Service.editChargeScheme = async function (params) {
    let request = {}
    // 计费策略id
    request['oid'] = params.OID;
    // 计费策略名
    request['rulename'] = params.rulename;
    // 备注
    request['description'] = params.description;
    // 计费策略是否可用（1默认可用，2不可用）
    request['usabletype'] = params.usabletype;

    let data = await $post('/ucenter/v2/base/editrule', request);
    return Service.handleCommonError(data)
}

// 添加计费策略
Service.addChargeScheme = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 计费策略名
    request['rulename'] = params.rulename;
    // 备注
    request['description'] = params.description;
    // 计费策略是否可用（1默认可用，2不可用）
    request['usabletype'] = params.usabletype;

    let data = await $post('/ucenter/v2/base/addrule', request);
    return Service.handleCommonError(data)
}

// 删除计费策略
Service.deteleChargeScheme = async function (params) {
    let request = {}
    // 计费策略id
    request['oid'] = params.OID;

    let data = await $post('/ucenter/v2/base/delrule', request);
    return Service.handleCommonError(data)
}
// 设置自动扣费
Service.auautomatic = async function (params){
	let request = {}
	// 计费策略id
	request['project_sys_id'] = Service.getProjectSystemId();
	request['is_automatic_deduction'] = params.is_automatic_deduction;
	let data = await $patch('/ucenter/v2/base/rule/automatic', request);
	return Service.handleCommonError(data)
}

// 修改计费设置
Service.editScheme_charge = async function (params) {
    let request = {}
    // 计费策略id
    request['oid'] = params.oid;
    // 	供水温度（冷）
    request['supply_temp_cool'] = params.supply_temp_cool;
    // 	回水温度（冷）
    request['back_temp_cool'] = params.back_temp_cool;
    // 	供水温度（热）
    request['supply_temp_hot'] = params.supply_temp_hot;
    // 	回水温度（热）
    request['back_temp_hot'] = params.back_temp_hot;
    // 	以供水或回水为标准（0默认，1供水，2回水）
    request['is_supply_or_back'] = params.is_supply_or_back;
    // 	计费条件（冷）
    request['allow_temp_cool'] = params.allow_temp_cool;
    // 	计费条件（热）
    request['allow_temp_hot'] = params.allow_temp_hot;

    // // 	夏季供冷开始时间
    // request['summer_cool_date_start'] = params.summer_cool_date_start;
    // // 	夏季供冷结束时间
    // request['summer_cool_date_end'] = params.summer_cool_date_end;
    // // 	冬季供热开始时间
    // request['winter_hot_date_start'] = params.winter_hot_date_start;
    // // 	冬季供热结束时间
    // request['winter_hot_date_end'] = params.winter_hot_date_end;
    // 	水流速设置
    request['water_velocity'] = params.water_velocity;

    //  是否自动计费（0默认，1自动计费，2手动计费）
    request['is_auto'] = params.is_auto;
    //  计费开关（0默认，1开，2关）
    request['manualchargingmode'] = params.manualchargingmode;

    let data = await $post('/ucenter/v2/base/charge', request);
    return Service.handleCommonError(data)
}

// 修改价格设置
Service.editScheme_price = async function (params) {
    let request = {}
    // 计费策略id
    request['project_sys_id'] = Service.getProjectSystemId();

    request['hm01_rule'] = JSON.stringify(params.hm01_rule);

	let data = await $patch('/ucenter/v2/base/rule/price', request);
    // let data = await $post('/ucenter/v2/base/price', request);
    return Service.handleCommonError(data)
}

// 修改欠费设置-新版本
Service.editarrearage = async function (params) {
    let request = {}
    // 计费策略id
    request['project_sys_id'] = Service.getProjectSystemId();

    request['account_day'] = JSON.stringify(params.account_day);

	let data = await $patch('/ucenter/v2/base/rule/accountday', request);
    return Service.handleCommonError(data)
}

// 修改欠费设置-老版本
Service.editScheme_arrearage = async function (params) {
    let request = {}
    // 计费策略id
    request['oid'] = params.oid;
    // 	是否预付费（0默认，1是，2不是）
    request['is_pre_pay'] = params.is_pre_pay;
    // 	预付费额度
    request['credit_line'] = params.credit_line;
    // 	后付费百分比
    request['credit_percent'] = params.credit_percent;
    // 	结算日
    request['account_day'] = params.account_day;

    let data = await $post('/ucenter/v2/base/arrearage', request);
    return Service.handleCommonError(data)
}

// 获取设备类型
Service.getConfigTerminalType = async function () {
    // 表计类型 （1当量温控器，2风柜，3热量表）
    let data = await $get("/ucenter/v2/devices/terminal_base");
    return Service.handleCommonError(data);
}

// 根据建筑id列表获取表记花费
Service.getTerminalcostbybidlist = async function (params) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;

    let data = await $get("/ucenter/v2/base/terminalcostbybidlist", params);
    return Service.handleCommonError(data);
}

// 根据表记ID获取该表记计费结果
Service.getTerminalcostbytid = async function (params) {
    let data = await $get("/ucenter/v2/base/terminalcostbytid", params);
    return Service.handleCommonError(data);
}

// 根据房间id获取表记花费
Service.getTerminalcostbyhid = async function (params) {
    let data = await $get("/ucenter/v2/base/terminalcostbyhid", params);
    return Service.handleCommonError(data);
}

// 根据住户id获取住户花费
Service.getHouseholdcostbyid = async function (params) {
    let data = await $get("/ucenter/v2/base/householdcostbyid", params);
    return Service.handleCommonError(data);
}

// 根据项目id获取所有住户花费
Service.getHouseholdcostbypid = async function (params) {
    // 项目Id
    params['project_id'] = Service.getProjectSystemId();
    if (!params['project_id']) return;
    
    let data = await $get("/ucenter/v2/base/householdcostbypid", params);
    return Service.handleCommonError(data);
}


// 批量导出房间花费账单
Service.exportAllHouseBill = async function (params) {
   let request = {}
   // 项目Id
   request['project_sys_id'] = Service.getProjectSystemId();
   if (!request['project_sys_id']) return;
   // 建筑list
   request['ids'] = params.ids;
   //是否为房间
   request['is_house'] = params.is_house;
   //是否缴费
   request['pay_status'] = params.pay_status;
   //业主名字
   request['household_name'] = params.household_name;
   //开始时间
   request['from'] = params.from;
   //结束时间
   request['to'] = params.to;
    let data = await $post("/ucenter/v2/base/bill/house/bill/export/all", request);
    return Service.handleCommonError(data);
}
// 导出单个房间花费账单
Service.exportHouseBill = async function (params) {
   let request = {}
   // 计费策略id
   request['bill_house_id'] = params.bill_house_id;
    let data = await $post("/ucenter/v2/base/bill/house/bill/export", request);
    return Service.handleCommonError(data);
}

// 获取基础配置
Service.getBaseDictionary = async function (params) {
    let data = await $get("/ucenter/v2/base/basicconfiguration", params);
    return Service.handleCommonError(data);
}

// 添加基础配置
Service.addBaseDictionary = async function (params) {
    let data = await $post("/ucenter/v2/base/basicconfiguration/add", params);
    return Service.handleCommonError(data);
}

// 修改
Service.editBaseDictionary = async function (params) {
    let data = await $post("/ucenter/v2/base/basicconfiguration/edit", params);
    return Service.handleCommonError(data);
}

// 修改是否可变
Service.editIsfixedBaseDictionary = async function (params) {
    let data = await $post("/ucenter/v2/base/basicconfiguration/editisfixed", params);
    return Service.handleCommonError(data);
}

// 根据code基础配置
Service.getCodeBaseDictionary = async function (params) {
    let data = await $get("/ucenter/v2/base/basicconfiguration/byoid", params);
    return Service.handleCommonError(data);
}

// 获取基础配置分类
Service.getTypeSystemDic = async function () {
    // let data = await $get("/ucenter/v2/sys/sysdict/typecode", params);
    // return Service.handleCommonError(data);
    return [
        {
            id: 1,
            type: 'plc_terminal_type',
            name: 'PLC子设备类型',
            disabled: false, 
        }
    ]
}

// 根据typecode基础配置
Service.getTypeCodeSystemDic = async function (params) {
    let data = await $get("/ucenter/v2/sys/sysdict/typecode", params);
    return Service.handleCommonError(data);
}

// 添加基础配置
Service.addSysdict = async function (params) {
    let data = await $post("/ucenter/v2/sys/sysdict/add", params);
    return Service.handleCommonError(data);
}

// 修改基础配置
Service.editSysdict = async function (params) {
    let data = await $post("/ucenter/v2/sys/sysdict/edit", params);
    return Service.handleCommonError(data);
}

// 获取天气
Service.getWeather = async function (params) {
    let data = await $get("/ucenter/v2/projects/weather", params);
    return Service.handleCommonError(data);
}

// 获取组态模板 
Service.getConfigurationTemp = async function (params) {
    let data = await $get("/ucenter/v2/map/serverroommaptemplate", params, true);
    return Service.handleCommonError(data);
}

// 添加校正
Service.addRequest = async function (params) {
   let request = {}
   request['collector_id'] = params.collector_id;
    let data = await $post("/ucenter/v2/devices/terminal/collector/addrequest", request);
    return Service.handleCommonError(data);
}


// 获取表计历史数据
Service.getHistoryReport = async function (params) {
	let request = {}
	request['terminal_id'] = params.terminal_id;
	request['time_interval'] = params.time_interval;
	//开始时间
	request['from'] = params.from;
	//结束时间
	request['to'] = params.to;
    let data = await $get("/ucenter/v2/devices/terminal/history", params, true);
    return Service.handleCommonError(data);
}